// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "a[data-v-70cfc13a] {\n  padding: 0 0.5em;\n  text-decoration: underline;\n}\na[data-v-70cfc13a]:hover {\n  text-decoration: none;\n}\n", ""]);
// Exports
module.exports = exports;
